import { TabContext } from '@mui/lab';

import { Paper } from '@ocx/ui';
import { OffersCarouselHeader } from './components';
import { OffersCarouselPanelController } from './offers-carousel-panel.controller';
import { OffersCarouselCategory } from './offers-carousel.types';

export type OffersCarouselControllerProps = {
  onCategoryChange: (categoryId: string) => void;
  categories: OffersCarouselCategory[];
  selectedCategory: OffersCarouselCategory | null;
};

export const OffersCarouselController = ({
  categories,
  selectedCategory,
  onCategoryChange,
}: OffersCarouselControllerProps) => {
  if (!categories.length || !selectedCategory) {
    return null;
  }

  return (
    <TabContext value={selectedCategory.id}>
      <Paper p={0} sx={{ overflow: 'hidden' }}>
        <OffersCarouselHeader categories={categories} onCategoryChange={onCategoryChange} />
        {categories.map(({ id, offers, banners }) => (
          <OffersCarouselPanelController id={id} key={id} offers={offers} banners={banners} />
        ))}
      </Paper>
    </TabContext>
  );
};
